export const API_CONFIG = {
  HEDGEY_PROOF_URL: 'https://api.hedgey.finance/token-claims/proof',
  HEDGEY_CLAIM_URL: 'https://app.hedgey.finance/claim/',
  HEDGEY_CAMPAIGNS_URL: 'https://mode-contentful.vercel.app/news.json',
  HEDGEY_TOKEN_CLAIMS_INFO_URL: 'https://api.hedgey.finance/token-claims/info',
  HEDGEY_GRAPHQL_ENDPOINT: 'https://api.hedgey.finance/hedgeyliteproduction-graphql',
};
